import React, { useCallback } from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import SliderCard from "../../../SliderCard";
import {
  SELECT_DRIVER_ROUTE_TO,
  SELECT_DRIVER_ROUTE,
  ALL_ROUTES,
  SUGGESTED_ROUTES,
} from "../../../../constants/strings";
import Autocomplete from "../../../Autocomplete";

const useStyles = makeStyles(() => ({
  sliderWrapper: {
    width: "50%",
  },
}));

export const SelectDriverRoute = ({
  options = [],
  onChange,
  value,
  label = SELECT_DRIVER_ROUTE,
  title = SELECT_DRIVER_ROUTE_TO,
  placeholder = null,
}) => {
  const classes = useStyles();

  const groupByManagers = useCallback(
    (option) => (option.isSuggested ? SUGGESTED_ROUTES : ALL_ROUTES),
    []
  );

  return (
    <SliderCard title={title}>
      <Box className={classes.sliderWrapper}>
        <Autocomplete
          onChange={onChange}
          value={value}
          label={label}
          variant="outlined"
          options={options}
          groupBy={groupByManagers}
          popperProps={{ placement: "bottom-start" }}
          placeholder={placeholder}
          dataTestId="select-driver/route"
        />
      </Box>
    </SliderCard>
  );
};

export default SelectDriverRoute;
